import { render, staticRenderFns } from "./StudyProgramAdd.vue?vue&type=template&id=5df93294&"
import script from "./StudyProgramAdd.vue?vue&type=script&lang=js&"
export * from "./StudyProgramAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports